import { registerGroup, registerRect, registerRichtext, registerSymbol, registerText } from '@visactor/vrender-kits';

export function loadTagComponent() {
  registerGroup();
  registerRect();
  registerSymbol();
  registerRichtext();
  registerText();
}
